// Splide
import { Splide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

// Style
import style from "./slideshow.module.scss";

// Components
import IconFA from '../icon-fa/icon-fa';

export default function Slideshow({ settings = {}, children }) {
  if (!settings) {
    return;
  }
  
  // Variables
  const slideshowSettings = settings;
  const carouselOptions = slideshowSettings.carouselOptions; // arrows, dots, numbers, progress, autoplay, drag, height, width

  var colorArrows = slideshowSettings.arrowColor ?? '';

  var breakpoints = {};
  if( slideshowSettings.slidesToDisplay > 1 ) {
    breakpoints = {
      992: {
        perPage: 2,
      },
      576: {
        perPage: 1,
      },
    }
  }

  // Define Splide Options
  var splideOptions = {
    type        : slideshowSettings?.type[0] ?? 'slide',
    perPage     : slideshowSettings.slidesToDisplay,
    arrows      : carouselOptions.includes('arrows') ?? false,
    pagination  : carouselOptions.includes('dots') ?? false,
    drag        : carouselOptions.includes('drag') ?? false,
    autoplay    : carouselOptions.includes('autoplay') ?? false,
    interval    : slideshowSettings.autoplayInterval ?? '0',
    gap         : slideshowSettings.slideGap,
    focus       : slideshowSettings.hasCenterFocus ? 'center' : 'number',
    // height      : customHeight,
    // width       : customWidth,
    breakpoints : breakpoints,
  };

  // Carousel Custom Sizes
  var customHeight = false;
  var customWidth = false;

  if( carouselOptions.includes('height') ) {
    customHeight = true;
    const customHeightFields = slideshowSettings.customHeightFields;
    switch( customHeightFields.heightType ) {
      case "height":
        splideOptions.height = customHeightFields.carouselMaxHeight ?? '';
        break;
      case "fixedHeight":
        splideOptions.fixedHeight = customHeightFields.slideFixedHeight ?? '';
        break;
      case "heightRatio":
        splideOptions.heightRatio = .5;
        break;
      case "autoHeight":
        splideOptions.autoHeight = true;
        break;
    }
  }
  if( carouselOptions.includes('width') ) {
    customWidth = true;
    const customWidthFields = slideshowSettings.customWidthFields;
    switch( customWidthFields.widthType ) {
      case "width":
        splideOptions.width = customWidthFields.carouselMaxWidth ?? '';
        break;
      case "fixedWidth":
        splideOptions.fixedWidth = customWidthFields.slideFixedWidth ?? '';
        break;
      case "autoWidth":
        splideOptions.autoWidth = true;
        break;
    }
  }

  // --- Splide Event Functions
  function splideMountedEvent(splide, newIndex = 0) {
    // Arrows Around Pagination
    const splidePagination = splide.Components.Elements.pagination;
    const splideArrows = splide.Components.Elements.arrows;
    const splideArrowsAroundPag = splide.Components.Elements.root.getAttribute('arrowsaroundpag');
    if( splidePagination && splideArrows && splideArrowsAroundPag ) {
      const pagWidth = splidePagination.offsetWidth;
      splideArrows.style.width = pagWidth + 'px';
    }
    // Set Nav Values on Load (Progress Width & Slide Numbers)
    updateSplideNavigation(splide, newIndex = 0);
  }
  function updateSplideNavigation(splide, newIndex = 0) {
    const splideProgress = splide.Components.Elements.root.querySelector(".splide__custom_progress__bar");
    const splideNumbers = splide.Components.Elements.root.querySelector(".splide__numbers");
    // Progress
    if( splideProgress ) {
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min( ( splide.index + 1 ) / end, 1 );
      splideProgress.style.width = String( 100 * rate ) + '%';
    }
    // Numbers
    if( splideNumbers ) {
      const slideCount = splide.Components.Elements.slides.length;
      splideNumbers.querySelector("span").textContent=(newIndex + 1) + "/" + slideCount;
    }
  }
  function updatePaginationColor(splide) {
    var colorPagination = slideshowSettings.paginationColor ?? '';
    if( colorPagination ) {
      const pagButton = splide.Components.Elements.pagination.querySelectorAll("button");
      pagButton.forEach( (item) => item.style.background = colorPagination );
    }
  }

  return(
    <Splide
      hasTrack={ false }
      options={ splideOptions }
      className={style.slideshow}
      aria-label="Slideshow"
      // Additional Attributes (for CSS)
      hasarrows={carouselOptions.includes('arrows') ? "true" : "false"}
      controlsoverslide={slideshowSettings.controlsOverSlide ? "true" : "false"}
      arrowsaroundpag={slideshowSettings.arrowsAroundPagination ? "true" : "false"}
      customsize={customHeight || customWidth ? "true" : "false"}
      // Events
      onMounted={ (splide) => splideMountedEvent(splide) }
      onPaginationMounted={ (splide) => updatePaginationColor(splide) }
      onMove={ ( splide, newIndex ) => updateSplideNavigation(splide, newIndex) }
    >
      <SplideTrack>
        {children}
      </SplideTrack>

      {carouselOptions.includes("progress") &&
      <div className={`${style.splideProgress} splide__progress`}>
        <div className="splide__custom_progress__bar" />
      </div>}

      {carouselOptions.includes("numbers") && <div className={`${style.splideNumbers} splide__numbers`}><span></span></div>}
      
      {carouselOptions.includes("arrows") &&
      <div
        className={`${style.splideArrows} splide__arrows`}
        style={{ color: `${colorArrows}` }}
      >
        <button className="splide__arrow splide__arrow--prev" direction="prev"><IconFA name="faChevronDown" color="var(--color--font)" /></button>
        <button className="splide__arrow splide__arrow--next" direction="next"><IconFA name="faChevronDown" color="var(--color--font)" /></button>
      </div>}

      {carouselOptions.includes("dots") && <ul className={`${style.splidePagination} splide__pagination`}></ul>}

    </Splide>
  )
}

